import api from './api';

const BILLING_SERVICE_URL = process.env.REACT_APP_FAST_FOOD_SERVICE || '';

const billingService = {
    // Obtener la configuración actual de Facturación Electrónica
    getConfig: async () => {
        const response = await api.get('/api/payments/billing/config/', { baseURL: BILLING_SERVICE_URL });
        return response.data;
    },

    // Guardar / Actualizar la configuración
    saveConfig: async (configData) => {
        const response = await api.post('/api/payments/billing/config/', configData, { baseURL: BILLING_SERVICE_URL });
        return response.data;
    },

    // Probar conexión y autenticación con KoaDoc API
    testConnection: async (data = {}) => {
        const response = await api.post('/api/payments/billing/test-connection/', data, { baseURL: BILLING_SERVICE_URL });
        return response.data;
    },

    // Emitir manualmente la factura de una orden ante el SRI
    emitOrderInvoice: async (orderId) => {
        const response = await api.post('/api/payments/billing/emit-order/', { order_id: orderId }, { baseURL: BILLING_SERVICE_URL });
        return response.data;
    },

    // Consultar estado de la factura en el SRI / KoaDoc
    getOrderInvoiceStatus: async (orderId) => {
        const response = await api.get(`/api/payments/billing/order-status/?order_id=${orderId}`, { baseURL: BILLING_SERVICE_URL });
        return response.data;
    }
};

export default billingService;
